import { useIntersectionObserver } from "@faire/web--source/ui/hooks/useIntersectionObserver";
import { useCallback } from "react";
/**
 * Use it to when you need an event to be fired when element becomes visible.
 * Note ATM this does not support inner scroll views, and only considers when things come into the window view only.
 * Usage
 * ```tsx
 * const MyComponent = () => {
 *     const elementRef = useDoActionWhenVisible((entry) => { ... do action when visible ...}, options)
 *
 *     return <div ref={elementRef} />
 * }
 * ```
 * @param doActionCallback
 * @param options
 */ export var useDoActionWhenVisible = function(doActionCallback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        threshold: 0,
        rootMargin: "0px"
    };
    var refCallback = useIntersectionObserver(function(entry, observer) {
        if (entry.isIntersecting && typeof doActionCallback === "function") {
            doActionCallback(entry);
            // manually disconnect the observer to avoid multiple calls
            observer.disconnect();
        }
    }, options);
    return useCallback(function(element) {
        refCallback(element);
    }, [
        refCallback
    ]);
};
